/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import OptionsBox from "module/components/form/inputs/select-field-combo/options-box";
import { xs, sm, md } from "module/components/form/inputs/select-field-combo/modal-styles";
import selectTop from "assets/img/select-top.svg";
import selectBottom from "assets/img/select-bottom.svg";
import { contains, isEmpty, length, find, propEq, join, filter, map, isNil } from "ramda";
import Parser from "application/components/parser";
import { exists } from "application/functions";
import getErrorCss from "module/functions/getErrrorCss";
import { translate } from "application/functions";
import ErrorInput from "assets/img/error-input";

const SelectFieldComboInput = (props) => {
  const {
    name,
    isMulti,
    options,
    onChange,
    onChangeMulti,
    size,
    path,
    defaultValue,
    errors,
    toggle,
    isHidden,
    hasSearch,
    hasPriceDiscount,
  } = props;
  const [showModal, setShowModal] = useState(false);
  const [showDropDown, setShowDropDown] = useState(false);
  const [showDropTop, setShowDropTop] = useState(false);
  const [multiValues, setMultiValues] = useState([]);
  const [value, setValue] = useState([]);

  const topRef = useRef(null);
  const downRef = useRef(null);

  useEffect(() => {
    const initialValue = defaultValue?.[`${path}.value`]?.[0];
    if (exists(initialValue)) {
      onChangeValues(initialValue);
    }
  }, [defaultValue]);

  useEffect(() => {
    setValue([]);
  }, [toggle]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.keyCode === 27) {
        // setValue(multiValues);
        // onChangeMulti(multiValues);
        setShowDropTop(false);
        setShowDropDown(false);
      }
    };

    const handleClickOutside = (e) => {
      if (isNil(e)) {
        setShowDropTop(false);
        setShowDropDown(false);
        return;
      }
      if (isNil(topRef.current) && isNil(downRef.current)) {
        return;
      }
      if (!isNil(topRef.current) && !topRef.current.contains(e.target)) {
        setValue(multiValues);
        onChangeMulti(multiValues);
        setShowDropTop(false);
      }
      if (!isNil(downRef.current) && !downRef.current.contains(e.target)) {
        setValue(multiValues);
        onChangeMulti(multiValues);
        setShowDropDown(false);
      }
    };
    // subscribe event
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape, false);
    return () => {
      // unsubscribe event
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape, false);
    };
  }, [multiValues]);

  const openSelect = () => {
    const modalSizes = ["md_horizontal", "sm_vertical", "xs_vertical"];
    if (contains(size, modalSizes)) {
      setShowModal(true);
    } else {
      const element = document.getElementById(`main-field-${path}`);
      // const space =
      // window.innerHeight - element.offsetTop + element.offsetHeight;
      const space = window.innerHeight - element.getBoundingClientRect().top;
      if (space >= 400) {
        setShowDropDown(true);
      } else {
        setShowDropTop(true);
      }
    }
  };

  const closeSelect = () => {
    setShowDropDown(false);
    setShowDropTop(false);
    setShowModal(false);
  };
  useEffect(() => {
    const header = document.querySelector(".form__form-header");
    if (showModal) {
      header.style.zIndex = 1;
    } else {
      header.style.zIndex = 101;
    }
  }, [showModal]);
  const getModalStyle = () => {
    switch (size) {
      case "xs_vertical":
        return xs;
      case "sm_vertical":
        return sm;
      default:
        return md;
    }
  };

  const onChangeValues = (inputValue) => {
    setShowDropDown(false);
    setShowDropTop(false);
    setShowModal(false);
    if (isMulti) {
      setValue(inputValue);
      onChangeMulti(inputValue);
    } else {
      const newValue = contains(inputValue, value) ? [] : [inputValue];
      setValue(newValue);
      onChange(newValue);
    }
  };

  const getBox = (isModal) => {
    return (
      <OptionsBox
        isMulti={isMulti}
        options={options}
        onChange={(value) => onChangeValues(value)}
        multiValues={multiValues}
        setMultiValues={(value) => setMultiValues(value)}
        isModal={isModal}
        closeSelect={closeSelect}
        hasSearch={hasSearch}
        hasPriceDiscount={hasPriceDiscount}
      />
    );
  };

  const getValueToShow = () => {
    if (length(value) === 1) {
      return find(propEq("value", value[0]))(options)?.label ?? "";
    }
    const filteredOptions = filter((option) => contains(option.value, value), options);
    return join(
      ", ",
      map((v) => v.label, filteredOptions)
    );
  };

  return (
    <Fragment>
      <div
        id={`main-field-${path}`}
        className={`select-field-combo-input__main-container${getErrorCss(`${path}.value`, errors)}`}
      >
        {showDropTop && (
          <div className="select-field-combo-input__droptop" ref={topRef}>
            {getBox(false)}
          </div>
        )}
        <div className={`select-field__labelfield ${!isEmpty(value) && "focus"}`}>
          <Parser text={name} hasValue={!isEmpty(value)} />
        </div>

        <div
          className={`select-field-combo-input__main-field${isEmpty(value) || isHidden ? "--without-value" : ""}`}
          onClick={() => openSelect()}
        >
          {!isEmpty(value) ? getValueToShow() : ""}
          <img
            className="select-field-combo-input__main-field-icon"
            src={showDropDown || showDropTop || showModal ? selectTop : selectBottom}
            alt={name}
          />
        </div>
        {showDropDown && (
          <div className="select-field-combo-input__dropdown" ref={downRef}>
            {getBox(false)}
          </div>
        )}
        <div className="errorsShowed">
          <ErrorInput />
          <span>{translate("field.required")}</span>
        </div>
      </div>
      <Modal
        id="for_options-box__container"
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        style={getModalStyle()}
        ariaHideApp={false}
      >
        {getBox(true)}
      </Modal>
    </Fragment>
  );
};

SelectFieldComboInput.propTypes = {
  name: PropTypes.string,
  isMulti: PropTypes.bool,
  options: PropTypes.array,
  onChange: PropTypes.func,
  onChangeMulti: PropTypes.func,
  size: PropTypes.string,
  hasPriceDiscount: PropTypes.any,
};

export default SelectFieldComboInput;
